import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Table } from '@/components/common/table';
import { otherColors } from '@/styles/colors';
import { media } from '@/styles/theme';
import { lineClamp } from '@/helpers';

const ResourceTableCell = styled(Table.Cell)<{ size?: number }>`
  margin: 0 0 0 18px;
  flex: ${({ size }) => size};

  &.resource-table-cell-label {
    width: 100%;
    white-space: break-spaces;

    ${lineClamp(2)}
    ${media.phone} {
      ${lineClamp(0)}
    }
  }
`;

const ResourceTableHeaderCell = styled(Table.HeaderCell)<{ size?: number }>`
  flex: ${({ size }) => size};
  margin: 0;
  padding-left: 18px;
  position: relative;
  display: flex;

  &::before {
    position: absolute;
    display: block;
    left: 0;
    top: 6px;
  }
`;

const ClickableResourceTableCell = styled(ResourceTableCell)`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-decoration-color: #007bff;
  }
`;

const ResourceTableRow = styled(Table.TableRow)`
  padding: 12px 16px;
  height: 64px !important;

  ${media.phone} {
    height: auto;
  }
`;

const ResourceTableHeader = styled(Table.Header)`
  align-items: center;
  padding: 0 16px;
`;

const ResourceTableTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 24px 0 20px;
  flex-wrap: wrap;
  gap: 10px;
`;

const ResourceTableTitle = styled.h3`
  font-size: 20px;
  font-weight: 300;
  margin: 0;
  color: ${otherColors.lxc.darkBlue};
`;

const TableSection = ({
  className,
  children,
  label,
}: {
  label?: string;
  className?: string;
  children?: React.ReactNode;
}): ReactElement => {
  return (
    <div className={className}>
      <TableSpacerContainer>
        <Spacer />
        <Label>{label}</Label>
        <Spacer />
      </TableSpacerContainer>
      {children}
    </div>
  );
};

const TableSpacerContainer = styled.div`
  width: 100%;
  padding: 4px;
  display: flex;
  align-items: center;
`;

const Spacer = styled.div`
  width: 100%;
  height: 0;
  border-bottom: 1px solid #dee2e6;
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin: 0 10px;
  white-space: nowrap;
`;

export {
  ResourceTableCell,
  ResourceTableHeaderCell,
  ClickableResourceTableCell,
  ResourceTableHeader,
  ResourceTableRow,
  ResourceTableTitleContainer,
  ResourceTableTitle,
  TableSection,
};
